<ng-template #productBodyTemplate>
  <lib-product-box-header [product]="product()" [lightMode]="lightMode()" [isNavProduct]="isNavProduct()" />
  <lib-product-box-description [product]="product()" [lightMode]="lightMode()" />
</ng-template>

@if (product()) {
  <lib-product-card [isOfferBox]="false" [cssClass]="cssClass()">
    <div
      class="product text-center h-full flex flex-col gap-y-4 border border-solid border-[--color-gray-3] rounded-[--border-radius-product-boxes]"
      [ngClass]="{
        'shadow-[0_4px_4px_rgba(0,0,0,0.15)]': !lightMode(),
        'shadow-[0_1px_2px_0_rgba(231,231,231,0.7)]': lightMode(),
      }"
      data-testid="product-box"
    >
      <div class="h-8">
        @if (promotion() && hasDiscountedCost() && !lightMode()) {
          <lib-promotion-banner [countdownDate]="countdownDate()" [text]="promotionBannerText()" />
        }
      </div>
      @if (!lightMode()) {
        <lib-link
          [attr.data-testid]="'product-' + product().product_code | lowercase"
          [link]="ctaLink()"
          [queryParams]="queryParams()"
          [queryParamsHandling]="'merge'"
          (onClick)="onProductBoxClick()"
          class="flex-auto flex flex-col [&>a]:flex-auto [&>a]:flex [&>a]:flex-col [&>a>span]:flex-auto"
        >
          <div class="flex flex-col h-full">
            <ng-container *ngTemplateOutlet="productBodyTemplate" />
          </div>
        </lib-link>
      } @else {
        <ng-container *ngTemplateOutlet="productBodyTemplate" />
      }
      <lib-product-box-cta
        class="w-full"
        [ctaLink]="ctaLink()"
        [queryParams]="queryParams()"
        [ctaLabel]="ctaLabel()"
        [ctaClasses]="ctaClasses()"
        (ctaClick)="onProductBoxClick()"
      >
        <lib-product-box-pricing
          class="flex flex-col gap-y-4"
          ngProjectAs="beforeCta"
          [product]="product()"
          [promotion]="promotion()"
          [lightMode]="lightMode()"
          [isNavProduct]="isNavProduct()"
        />

        @if (enablePromotionOverride && featureFlagService.isOn('product-box-alternative-default-promotion')) {
          <div class="h-10" ngProjectAs="afterCta">
            @if (showPromotionsDialogTrigger()) {
              <lib-button
                (clickEvent)="openPromotionsDialog()"
                [text]="['product_selection', 'promotions_modal_trigger_btn_text'] | translate"
                type="mat-text-button"
              />
            }
          </div>
        }
      </lib-product-box-cta>

      @if (!lightMode()) {
        <lib-product-box-footer
          [showLearnMore]="showLearnMore()"
          [productCode]="product().product_code"
          [productDetailsLink]="productDetailsLink()"
          [activationFee]="activationFee()"
          [contractDuration]="contractDuration()"
        />
      }
    </div>
  </lib-product-card>
}
